<template >
  <van-row>
    <van-row class="order-info">
      <van-col
        span="18"
        style="margin-top: 5px;"
      >{{generateCustomizeString('createAt')}} {{orderDetailData.created_at | toLocalTime }}
      </van-col>
      <van-col
        span="6"
        style="text-align: right;"
        v-if="orderDetailData.is_pick_up === 1"
      >
        <van-tag
          type="primary"
          plain
          style="margin-bottom: 5px;"
        >{{generateCustomizeString('pickUp')}}</van-tag>
      </van-col>
      <van-col
        class="member-info"
        span="24"
        v-if="wechatDetail.headimgurl"
      >
        <van-col>
          <img
            height="40"
            width="40"
            v-lazy="wechatDetail.headimgurl"
            style="padding-top: 3px; margin-left: 5px;"
          >
        </van-col>
        <van-col style="margin-left: 10px; width: 80%;">
          <van-col span="20">
            <span>{{ generateCustomizeString('wechatName') }} {{wechatDetail.nickname}}</span>
            <span v-if="wechatDetail.remark"> ({{wechatDetail.remark}})</span>
          </van-col>
          <van-col span="20">{{ generateCustomizeString('phone') }} {{orderDetailData.customer_name}}
          </van-col>
        </van-col>
      </van-col>
      <van-col
        class="member-info"
        span="24"
        v-else
      >
        <van-col span="24">
          <span>{{ generateCustomizeString('wechatName') }} {{wechatDetail.nickname ? wechatDetail.nickname : generateCustomizeString('unbound')}}</span>
          <span v-if="wechatDetail.remark"> ({{wechatDetail.remark}})</span>
        </van-col>
        <van-col span="24">{{ generateCustomizeString('phone') }} {{orderDetailData.customer_name}}
        </van-col>
      </van-col>
    </van-row>
    <van-row
      v-if="orderDetailData.order_fee_detail"
      style="margin-top: 5px; padding-bottom: 10px; border-radius: 3px; background: #fff;"
    >
      <van-col span="24">
        <van-cell-group>
          <van-cell :title="generateCustomizeString('orderActivity')"></van-cell>
        </van-cell-group>
        <div v-if="orderFeeDetail.use_activity_list && orderFeeDetail.use_activity_list.length > 0">
          <div v-for="item in orderFeeDetail.use_activity_list" :key="item.id">
            <div class="promotion-info">{{item.title}}</div>
          </div>
        </div>
        <div
          v-else
          class="promotion-info"
        >{{generateCustomizeString('none')}}</div>
      </van-col>
    </van-row>
    <van-row
      v-if="orderDetailData.order_fee_detail"
      style="margin-top: 5px; padding-bottom: 10px; border-radius: 3px; background: #fff;"
    >
      <van-col span="24">
        <van-cell-group>
          <van-cell :title="generateCustomizeString('orderCoupon')"></van-cell>
        </van-cell-group>
        <div v-if="orderFeeDetail.use_coupon_list && orderFeeDetail.use_coupon_list.length > 0">
          <div v-for="item in orderFeeDetail.use_coupon_list" :key="item.id">
            <div class="promotion-info">{{item.title}}</div>
          </div>
        </div>
        <div
          v-else
          class="promotion-info"
        >{{generateCustomizeString('none')}}</div>
      </van-col>
    </van-row>
    <van-row style="margin-top: 5px; background: #fff; border-radius: 3px;">
      <van-col span="24">
        <van-cell-group v-if="orderDetailData.order_fee_detail">
          <van-cell
            :title="generateCustomizeString('originalGoodsFee')"
            :value="'NZD $' + orderFeeDetail.total_goods_fee"
          />
          <van-cell
            v-if="orderFeeDetail.use_activity_list.length > 0 && orderFeeDetail.use_coupon_list.length === 0"
            :title="generateCustomizeString('discountedGoodsFee')"
            :value="'NZD $' + orderFeeDetail.total_goods_fee_after_discounted"
            :label="'$' + orderFeeDetail.total_goods_fee + ' - ' + '$' + orderFeeDetail.total_activity_reduction + generateCustomizeString('promotionActivity')"
          />
          <van-cell
            v-else-if="orderFeeDetail.use_coupon_list.length > 0 && orderFeeDetail.use_activity_list.length === 0"
            :title="generateCustomizeString('discountedGoodsFee')"
            :value="'NZD $' + orderFeeDetail.total_goods_fee_after_discounted"
            :label="'$' + orderFeeDetail.total_goods_fee + ' - ' + '$' + orderFeeDetail.total_coupon_reduction + generateCustomizeString('couponActivity')"
          />
          <van-cell
            v-else-if="orderFeeDetail.use_coupon_list.length > 0 && orderFeeDetail.use_activity_list.length > 0"
            :title="generateCustomizeString('discountedGoodsFee')"
            :value="'NZD $' + orderFeeDetail.total_goods_fee_after_discounted"
            :label="'$' + orderFeeDetail.total_goods_fee + ' - ' + '$' + orderFeeDetail.total_activity_reduction + generateCustomizeString('promotionActivity') + ' - ' + '$' + orderFeeDetail.total_coupon_reduction + generateCustomizeString('couponActivity')"
          />
          <van-cell
            v-else
            :title="generateCustomizeString('discountedGoodsFee')"
            :value="'NZD $' + orderFeeDetail.total_goods_fee_after_discounted"
          />
          <van-cell
            :title="generateCustomizeString('originalShippingFee')"
            :value="'NZD $' + orderFeeDetail.total_express_fee"
          />
          <van-cell
            v-if="orderFeeDetail.total_express_fee !== orderFeeDetail.total_express_fee_after_discounted"
            :title="generateCustomizeString('discountedShippingFee')"
            :value="'NZD $' + orderFeeDetail.total_express_fee_after_discounted"
            :label="'$' + orderFeeDetail.total_express_fee + ' - ' + '$' + orderFeeDetail.total_express_fee_reduction + generateCustomizeString('promotionActivity')"
          />
          <van-cell
            v-else
            :title="generateCustomizeString('discountedShippingFee')"
            :value="'NZD $' + orderFeeDetail.total_express_fee_after_discounted"
          />
          <van-cell
            :title="generateCustomizeString('orderShopPrice')"
            :value="'NZD $' + orderFeeDetail.total_fee_after_discounted"
            :label="'$' + orderFeeDetail.total_goods_fee_after_discounted + ' + ' + '$' + orderFeeDetail.total_express_fee_after_discounted"
          />
          <van-cell
            :title="generateCustomizeString('agentProfit')"
            :value="'NZD $' + orderFeeDetail.profit"
          />
          <van-cell
            v-if="parseFloat(orderFeeDetail.profit) !== 0.00"
            :title="generateCustomizeString('orderFinalPrice')"
            :value="'NZD $' + orderFeeDetail.fee"
            :label="'$' + orderFeeDetail.total_fee_after_discounted + ' + ' + '$' + orderFeeDetail.profit"
          />
          <van-cell
            v-else
            :title="generateCustomizeString('orderFinalPrice')"
            :value="'NZD $' + orderFeeDetail.fee"
          />
        </van-cell-group>
        <van-cell-group v-else>
          <van-cell
            :title="generateCustomizeString('goodsValueBeforeDiscount')"
            :value="'NZD $' + orderDetailData.goods_fee_before_discounted / 100"
          />
          <van-cell
            :title="generateCustomizeString('expressFeeBeforeDiscount')"
            :value="'NZD $' + orderDetailData.express_fee_before_discounted / 100"
          />
          <van-cell
            :title="generateCustomizeString('goodsFeeAfter')"
            :value="'NZD $' + orderDetailData.goods_fee / 100"
          />
          <van-cell
            :title="generateCustomizeString('expressFeeAfter')"
            :value="'NZD $' + orderDetailData.express_fee / 100"
          />
          <van-cell
            :title="generateCustomizeString('finalFee')"
            :value="'NZD $' + orderDetailData.fee / 100"
          />
        </van-cell-group>
      </van-col>
    </van-row>
    <van-row
      class="order-sender"
      v-if="orderAddress"
    >
      <van-col>
        <div><b>{{generateCustomizeString('consignee')}} {{orderAddress.consignee_name}}</b></div>
        <div>{{generateCustomizeString('phone')}} {{orderAddress.phone}}</div>
        <div>{{generateCustomizeString('idCardNo')}} {{orderAddress.person_id ? orderAddress.person_id : generateCustomizeString('none')}}</div>
        <div v-if="orderAddress.country === '新西兰'">{{generateCustomizeString('address')}} {{orderAddress.country + ' ' + orderAddress.city + ' ' + orderAddress.shipping_address}}</div>
        <div v-else>{{generateCustomizeString('address')}} {{orderAddress.country + ' ' + orderAddress.state + ' ' + orderAddress.city + ' ' + orderAddress.district + ' ' + orderAddress.shipping_address}}</div>
      </van-col>
    </van-row>
    <van-row
      class="order-sender"
      v-if="orderSender !== null"
    >
      <van-col>
        <div><b>{{generateCustomizeString('consigner')}} {{orderSender.sender_name}}</b></div>
        <div>{{generateCustomizeString('phone')}} {{orderSender.phone}}</div>
        <div>{{generateCustomizeString('address')}} {{orderSender.address}}</div>
      </van-col>
    </van-row>
    <van-row style="margin-top: 5px; background: #fff; border-radius: 3px;">
      <van-col span="24">
        <van-cell-group style="">
          <van-cell
            :title="generateCustomizeString('customerMessage')"
            :label="orderDetailData.message ? orderDetailData.message : generateCustomizeString('none')"
          />
          <van-cell
            :title="generateCustomizeString('paidAt')"
            :value="orderDetailData.paid_at ? orderDetailData.paid_at : generateCustomizeString('none')"
          />
          <van-cell
            :title="generateCustomizeString('shippingAt')"
            :value="orderDetailData.delivery_at ? orderDetailData.delivery_at : generateCustomizeString('none')"
          />
          <van-cell
            :title="generateCustomizeString('finishedAt')"
            :value="orderDetailData.finished_at ? orderDetailData.finished_at : generateCustomizeString('none')"
          />
        </van-cell-group>
      </van-col>
    </van-row>
  </van-row>
</template>

<script>
import { generateCustomizeString } from '@/utils/i18n'
import { Row, Col, Uploader, Icon, Button, Cell, CellGroup, Tag } from 'vant'

export default {
  name: 'OrderInfo',
  components: {
    [Uploader.name]: Uploader,
    [Icon.name]: Icon,
    [Row.name]: Row,
    [Col.name]: Col,
    [Button.name]: Button,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Tag.name]: Tag
  },
  data() {
    return {
      active: 0,
      activeTab: 0,
      imgLink: 'https://img.nzmai.com.cn/000robbme4_1537254820869.jpg'
    }
  },
  props: {
    orderDetailData: {
      type: Object,
      default: () => ({})
    },
    orderSender: {
      type: Object,
      default: () => ({})
    },
    orderAddress: {
      type: Object,
      default: () => ({})
    },
    wechatDetail: {
      type: Object,
      default: () => ({})
    },
    orderTransaction: {
      type: Array,
      default: () => ([])
    },
    orderFeeDetail: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    generateCustomizeString
    // onClickLeft() {
    //   this.$router.replace({ name: 'Orders' })
    // }
  },
  created: function() {
    // Add barcode scan listener and pass the callback function
    // this.RegisterWxJsApi()
    console.log(this.orderDetailData)
  }
}
</script>

<style lang="less" scoped>
.order-info {
  padding: 10px 10px 20px 10px;
  line-height: 1.2rem;
  border-radius: 5px;
  background: #fff;
}
.member-info {
  margin-top: 5px;
  line-height: 1.5rem;
  border-radius: 3px;
  padding: 0.3rem;
  text-align: left;
  background: #f7f7f7;
  color: #3c3c3c;
}
.order-sender {
  margin-top: 5px;
  padding: 20px;
  background: #fff;
  border-radius: 5px;
  line-height: 1.5rem;
}
.promotion-info {
  padding-top: 10px;
  text-align: center;
  color: #969799;
}
</style>
